import React, { useEffect, useState } from 'react';
import moment from 'moment';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { CustomComponentEditor } from '../custom-component/CustomComponentEditor';
import CustomReactPaginate from '../../../common/custom/CustomReactPaginate';
import EnvironmentSelect from '../../../common/formElements/EnvironmentSelect';
import { CustomFunctionEditor } from './CustomFunctionEditor';

function CustomFunctionLogs({
  customFunctionId,
  collections,
  history,
  pages,
  events,
  projectId,
  actions,
  version,
}) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('customFunction');
  const [expandedLogIndex, setExpandedLogIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 25;

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const response = await actions.customFunctionLogs({ projectId, customFunctionId });
      console.log('This is the response from the log API:', response);
      setLogs((response.data || []).reverse());

      if (name === 'customFunction') {
        const nameData = await actions.loadCustomFunctionDetail({ projectId, customFunctionId });
        const data = nameData.data;
        const name = data.name || '';
        setName(name);
      }
      setExpandedLogIndex(null);
    } catch (error) {
      console.error('Error fetching logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customFunctionId) {
      fetchLogs();
    }
  }, [customFunctionId]);

  const refreshItemForm = fetchLogs;

  const toggleLog = (index) => {
    setExpandedLogIndex(expandedLogIndex === index ? null : index);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
    setExpandedLogIndex(null);
  };

  const offset = (currentPage - 1) * perPage;
  const paginatedLogs = logs.slice(offset, offset + perPage);
  const totalPages = Math.ceil(logs.length / perPage);

  const renderLogsTable = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan="3" className="text-center">
            Loading logs...
          </td>
        </tr>
      );
    }

    if (!logs.length) {
      return (
        <tr>
          <td colSpan="3" className="text-center">
            No logs found.
          </td>
        </tr>
      );
    }

    return paginatedLogs.flatMap((logItem, index) => {
      const actualIndex = offset + index;
      const uniqueKey = `${logItem.activationId || 'no-id'}-${actualIndex}`;

      return [
        <tr key={uniqueKey}>
          <td>{moment(logItem.timestamp).format('Do MMM YYYY hh:mm:ss A')}</td>
          <td>{logItem.activationId || 'N/A'}</td>
          <td>
            <button className="btn btn-xs btn-primary" onClick={() => toggleLog(actualIndex)}>
              {expandedLogIndex === actualIndex ? 'Hide Logs' : 'View Logs'}
            </button>
          </td>
        </tr>,
        expandedLogIndex === actualIndex && (
          <tr key={`${uniqueKey}-details`}>
            <td colSpan="3">
              <CustomFunctionEditor
                value={JSON.stringify(logItem.logs || [], null, 2)}
                mode="json"
              />
            </td>
          </tr>
        ),
      ];
    });
  };

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol
        title={name + ' ' + 'logs'}
        icon="customFunction"
        bgColor="drapcode-violet"
        CtaComponent={
          <>
            <button className="btn btn-md btn-default" onClick={refreshItemForm} disabled={loading}>
              <i className="wb webconnect-refresh" />
            </button>
          </>
        }
      >
        <div className="row justify-content-end">
          <div className="col-sm-12 col-md-3 mb-3">
            <EnvironmentSelect
              projectId={projectId}
              version={version}
              refreshMethod={refreshItemForm}
              environment={collections.projectDetails}
              actions={actions}
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm table-word-break connector-list">
            <thead>
              <tr>
                <th>Date</th>
                <th>Activation ID</th>
                <th>Logs</th>
              </tr>
            </thead>
            <tbody>{renderLogsTable()}</tbody>
          </table>
        </div>
        <div className="mt-3">
          <CustomReactPaginate
            totalPages={totalPages}
            page={currentPage - 1}
            onPageChange={handlePageChange}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
          />
        </div>
      </ParentCardNoCol>
    </div>
  );
}

export default CustomFunctionLogs;
